import { configureStore } from "@reduxjs/toolkit";
import { contactApi } from "./api/ContactApi/contactApi";
import { servicesDataApi } from "./api/ServicesDataApi/servicesDataApi";
import { MarqueeDataApi } from "./api/MarqueeApi/marqueeApi";
import { servicesApi } from "./api/ServicesApi/servicesApi";
import { FAQApi } from "./api/FAQApi/FAQApi";
import { testimonialApi } from "./api/TestimonialApi/testimonialApi";
import { statsApi } from "./api/StatsApi/statsApi";
import { clientsApi } from "./api/ClientsApi/clientsApi";
import { timelineApi } from "./api/TimelineApi/timelineApi";
import { worksApi } from "./api/WorksApi/worksApi";
import { careersApi } from "./api/CareersApi/careersApi";

import { authApi } from "./api/AuthApi/authApi";
import { userApi } from "./api/UserApi/userApi";
import { notificationApi } from "./api/NotificationApi/notificationApi";
import { blogsApi } from "./api/BlogsApi/blogsApi";
import { blogCategoriesApi } from "./api/BlogCategoriesApi/blogCategoriesApi";
import { settingsApi } from "./api/SettingsApi/settingsApi";
import { dashboardApi } from "./api/DashboardApi/dashboardApi";
import { vaultApi } from "./api/VaultApi/vaultApi";
import authReducer from "./slices/authSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    [authApi.reducerPath]: authApi.reducer,
    [contactApi.reducerPath]: contactApi.reducer,
    [servicesDataApi.reducerPath]: servicesDataApi.reducer,
    [MarqueeDataApi.reducerPath]: MarqueeDataApi.reducer,
    [servicesApi.reducerPath]: servicesApi.reducer,
    [FAQApi.reducerPath]: FAQApi.reducer,
    [testimonialApi.reducerPath]: testimonialApi.reducer,
    [statsApi.reducerPath]: statsApi.reducer,
    [clientsApi.reducerPath]: clientsApi.reducer,
    [timelineApi.reducerPath]: timelineApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [worksApi.reducerPath]: worksApi.reducer,
    [careersApi.reducerPath]: careersApi.reducer,
    [notificationApi.reducerPath]: notificationApi.reducer,
    [blogsApi.reducerPath]: blogsApi.reducer,
    [blogCategoriesApi.reducerPath]: blogCategoriesApi.reducer,
    [settingsApi.reducerPath]: settingsApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    [vaultApi.reducerPath]: vaultApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      authApi.middleware,
      contactApi.middleware,
      servicesDataApi.middleware,
      MarqueeDataApi.middleware,
      servicesApi.middleware,
      FAQApi.middleware,
      testimonialApi.middleware,
      statsApi.middleware,
      clientsApi.middleware,
      timelineApi.middleware,
      userApi.middleware,
      worksApi.middleware,
      careersApi.middleware,
      notificationApi.middleware,
      blogsApi.middleware,
      blogCategoriesApi.middleware,
      settingsApi.middleware,
      dashboardApi.middleware,
      vaultApi.middleware,
    ]),
});
